const KYCSubmissionStatus = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "declined",
  Deleted: "deleted",
  Expired: "expired",
};

export default KYCSubmissionStatus;
